import * as React from 'react'

/* Import components here */
import {
  StyledListSortDemo,
  StyledContainer,
  StyledList,
  StyledText,
  StyledWrapper,
  StyledCircleWrapper,
  StyledCircle,
  Content,
  Extra,
  Wrap
} from './ListSortDemo.styles'

/* Import interfaces here */
import { IListSortDemoProps, IListSortDemoState } from './ListSortDemo.interfaces'

/* Import utilities here */
import Icon from 'antd/lib/icon'
// import PropTypes from 'prop-types'
import ListSort from './ListSort'
import { Form, Input, Button } from 'antd'
import { withFirebase } from '../../firebase'
import { compose } from 'recompose'
// import { rootStore } from 'stores'
import { observer } from 'mobx-react'

let id = 5

@observer
export class ListSortDemo extends React.Component<IListSortDemoProps, IListSortDemoState> {
  public state = {
    editing: false,
    priorityList: []
  }

  componentDidMount() {
    this.props.firebase
      .settings()
      .get()
      .then(doc => {
        if (doc.exists) {
          console.log('Document data:', doc.data())
          this.setState({ priorityList: doc.data().priorities })
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!')
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
      })
  }

  toggleEditing = () => {
    this.setState({ editing: !this.state.editing })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { keys, names } = values
        console.log('Received values of form: ', values)
        console.log(
          'Merged values:',
          keys.map(key => names[key])
        )
        /* console.log(
          'SETSTATE',
          Array.from(keys.sort(), (key: any) => names[key])
        ) */
        //this.setState({ priorityList: Array.from(keys.sort(), (key: any) => names[key]) })
        const namesField: any[] = []
        keys.forEach(k => {
          namesField[k] = names[k]
        })
        console.log('NAMEFIELD', namesField)
        // this.props.form.setFieldsValue({
        //   names: namesField
        // })
        this.setState({ priorityList: namesField })

        const priorities = keys.map(key => names[key])
        console.log('PRIORITIES TO FIREBASE', priorities)
        this.props.firebase
          .settings()
          .update({
            priorities
          })
          .then(() => this.toggleEditing())
      }
    })
  }

  setKeys = objectArray => {
    const { form } = this.props
    const { priorityList, editing } = this.state
    if (Array.isArray(objectArray)) {
      form.setFieldsValue({
        keys: Array.from(objectArray, (x: any) => parseInt(x.key))
      })
      if (!editing) {
        const currentOrderList: any[] = []
        objectArray.forEach(k => {
          const i = parseInt(k.key)
          currentOrderList.push(priorityList[i])
        })
        this.props.firebase.settings().update({
          priorities: currentOrderList
        })
      }
    }
  }

  add = () => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    const nextKeys = keys.concat(id++)
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys
    })
  }

  remove = k => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    // We need at least one
    if (keys.length === 1) {
      return
    }
    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    })
  }

  public render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { editing, priorityList } = this.state
    getFieldDecorator('keys', {
      initialValue: priorityList.map((x, index) => index)
    })
    const keys = getFieldValue('keys')
    const color = '#FF5500'
    const childrenToRender = keys.map((key, index) => {
      if (editing) {
        return (
          <StyledList key={key}>
            <StyledCircleWrapper>
              <StyledCircle>{index + 1}</StyledCircle>
            </StyledCircleWrapper>
            <StyledText>
              <Form.Item>
                {getFieldDecorator(`names[${key}]`, {
                  initialValue: priorityList[key],
                  validateTrigger: ['onChange', 'onBlur'],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: 'Vänligen skriv in en priortiet eller ta bort fält'
                    }
                  ]
                })(
                  <Input
                    placeholder="Prioritet"
                    style={{ textAlign: 'center', marginRight: '8px', width: '80%' }}
                  />
                )}
                {keys.length > 1 ? (
                  <Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    style={{ color }}
                    onClick={() => this.remove(key)}
                  />
                ) : null}
              </Form.Item>
            </StyledText>
          </StyledList>
        )
      }
      return (
        <StyledList key={key}>
          <StyledCircleWrapper>
            <StyledCircle>{index + 1}</StyledCircle>
          </StyledCircleWrapper>
          <StyledText>
            <h1 style={{ textAlign: 'center', margin: '5px', width: '80%' }}>
              {priorityList[key]}
            </h1>
          </StyledText>
        </StyledList>
      )
    })

    return (
      <StyledListSortDemo>
        <Wrap>
          <Content>
            <h1>Priorities</h1>
          </Content>
          <Extra>
            <Icon type="ordered-list" />
          </Extra>
        </Wrap>
        <StyledWrapper>
          <StyledContainer>
            <Form onSubmit={this.handleSubmit}>
              <ListSort
                onChange={this.setKeys}
                dragClassName="list-drag-selected"
                appearAnim={{ animConfig: { marginTop: [5, 30], opacity: [1, 0] } }}
              >
                {childrenToRender}
              </ListSort>
              {editing && (
                <>
                  <Form.Item style={{ marginBottom: '0px' }}>
                    <Button type="dashed" onClick={this.add} style={{ width: '100%' }}>
                      <Icon type="plus" /> Lägg till fält
                    </Button>
                    {/* <Button
                      disabled={keys.length < 2}
                      type="dashed"
                      onClick={this.remove}
                      style={{ width: '49%', marginLeft: '2%' }}
                    >
                      <Icon type="minus" /> Ta bort fält
                    </Button> */}
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                      Ändra
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form>
            {!editing && (
              <Button
                type="primary"
                style={{ width: '100%', marginTop: '20px' }}
                onClick={this.toggleEditing}
              >
                Editera
              </Button>
            )}
          </StyledContainer>
        </StyledWrapper>
      </StyledListSortDemo>
    )
  }
}

const PriorityForm = Form.create({ name: 'Priorities' })(compose(withFirebase)(ListSortDemo))

export default PriorityForm
